import React from "react";
import { Container, Row, Col } from "reactstrap";

const PageOne = () => {
  return (
    <Container fluid={true} className="main-body-container">
      <Row>
        <Col xs="1" md="3"></Col>
        <Col xs="10" md="8">
          <h2>
            Heroism in battle is traditionally celebrated with a statue. Every day, the staff at St. Jude Children's
            Research Hospital witness extraordinary bravery from kids battling cancer and other life-threatening
            diseases. But these inspiring kids have never been celebrated with statues.
          </h2>
        </Col>
        <Col xs="1" md="1"></Col>
      </Row>
      <Row>
        <Col xs="1" md="6"></Col>
        <Col xs="10" md="4">
          <h3>
            No matter what she was going through, she just had this peace about her. I don’t think she was ever afraid;
            if she was, she never let it on.
          </h3>
          <h4 style={{ textAlign: "right" }}>-Annika's Mom</h4>
        </Col>
        <Col xs="1" md="2"></Col>
      </Row>
    </Container>
  );
};

export default PageOne;
